import React, { useCallback, useEffect, useState } from 'react';
import { api, formatCOP } from '../services/api';
import { IS_FACTURACION } from '../config';
import { entregaParts, pedidoClienteDisplay } from '../utils/entregaAddress';

function hoyISO() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

function fechaCompletado(p) {
  const raw = IS_FACTURACION
    ? p.facturado_fin_at || p.facturado_inicio_at || p.preparado_at || p.updated_at
    : p.preparado_at || p.updated_at;
  if (!raw) return '';
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return String(raw).slice(0, 10);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

function fmtHora(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit' });
}

export default function BodegaSidebarHistorial({ pin, selectedId, onSelect, refreshKey }) {
  const [fecha, setFecha] = useState(hoyISO);
  const [pedidos, setPedidos] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    setPedidos([]);
    try {
      const res = await api.getHistorial({ fecha });
      const items = (Array.isArray(res.data) ? res.data : []).filter(
        (p) => fechaCompletado(p) === fecha
      );
      setPedidos(items);
    } catch {
      setPedidos([]);
    } finally {
      setLoading(false);
    }
  }, [pin, fecha]);

  useEffect(() => {
    load();
    const t = setInterval(load, 45000);
    const onVis = () => {
      if (document.visibilityState === 'visible') load();
    };
    document.addEventListener('visibilitychange', onVis);
    return () => {
      clearInterval(t);
      document.removeEventListener('visibilitychange', onVis);
    };
  }, [load, refreshKey]);

  return (
    <div className="sidebar-historial">
      <div className="sidebar-historial-head">
        <h3>{IS_FACTURACION ? 'Facturados' : 'Historial'}</h3>
        <span className="sidebar-historial-count">{pedidos.length}</span>
      </div>
      <label className="sidebar-fecha">
        <span>Día</span>
        <input type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} />
      </label>
      <p className="sidebar-historial-sub">
        {IS_FACTURACION ? 'Facturados del equipo' : 'Completados del equipo'}
      </p>

      {loading ? (
        <p className="sidebar-historial-empty">Cargando...</p>
      ) : pedidos.length === 0 ? (
        <p className="sidebar-historial-empty">Sin pedidos este día</p>
      ) : (
        <ul className="sidebar-historial-list">
          {pedidos.map((p) => (
            <li key={p.id}>
              <button
                type="button"
                className={`sidebar-hist-row ${selectedId === p.id ? 'selected' : ''}`}
                onClick={() => onSelect(p.id)}
              >
                <strong>{p.numero}</strong>
                <span>
                  {pedidoClienteDisplay(p)}
                  {(p.es_sede || p.padre_codigo) ? ' · Sucursal' : ''}
                </span>
                {(() => {
                  const e = entregaParts(p);
                  if (!e.line) return null;
                  return <span className="sidebar-hist-dir">{e.direccion || e.ciudadZona}</span>;
                })()}
                <em>
                  {fmtHora(p.preparado_at || p.created_at)}
                  {p.preparado_por_nombre ? ` · ${p.preparado_por_nombre}` : ''} ·{' '}
                  {formatCOP(p.subtotal)}
                </em>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
